module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Light.94824c3.woff2";